// Start of prototype table
// --------------------
// @author: Han Speerstra

myTable.fn = myTable.prototype;

export default function myTable($new_config)
{
	var that = this;

	this.config = $new_config;
	this.table_id = this.config.table_id;

	this.data = {};
	this.inProgress = false;
	this.first_request;
	this.force_reset_table;
	this.spinner;

	that.config.show = false;
	if( ! this.config.bootstrap) this.config.bootstrap = 3;
	this.config.selector = '#' + this.table_id + ' table tbody';
	if(this.config.overwrite_selector) {
		this.config.selector = this.config.overwrite_selector;
	}

	this.table_init();
}

myTable.fn.table_init = function()
{
	var that = this;

	this.table_id 	= this.table_id;
	var $chk_state 	= '';
	var $checkbox 	= '';

	// init spinner
	that.spinner = new spinner({"target" : '#' + that.table_id + ' table', "delay" : 500, "fade" : 0});

	this.init_table_controls();
	this.init_table_header();

	// prevent table elements from being accidentally selected
	$("#" + this.table_id).addClass('unselectable');

	$("#" + this.table_id + ' table').mousedown(function(event)
	{
		// event.preventDefault();

		if(event.which === 1) //left mouse button only
		{
			var $tr = $(event.target).closest('tr');
			var $row_id = $tr.data('id');

			// select row when checkbox is clicked
			if($(event.target).hasClass("checkbox"))
			{
				$checkbox = $(event.target);
				$chk_state = that.toggle_row($checkbox, $tr, 'auto_toggle');

				if($(event.target).hasClass("toggle-all-rows")) {
					that.toggle_all_rows($chk_state);
				}

				if(that.config.select_callback) {
                    var selected = that.get_selected_rows(); // jquery object

                    that.config.select_callback(that, event, selected);
                    console.log('Excecuting select callback of table: ' + that.table_id);
                }
                else {
                	that.toggle_table_controls();
                }

                return false;
            }

			// select row
			if($(event.target).hasClass("checkbox-wrap"))
			{
				$checkbox = $(event.target).find(':checkbox');
				$chk_state = that.toggle_row($checkbox, $tr, 'auto_toggle');

				if($(event.target).hasClass("toggle-all-rows")) {
					that.toggle_all_rows($chk_state);
				}

				if(that.config.select_callback) {
				    var selected = that.get_selected_rows(); // jquery object

				    that.config.select_callback(that, event, selected);
				    console.log('Excecuting select callback of table: ' + that.table_id);
				}
				else {
					that.toggle_table_controls();
				}

				return false;
			}

			// click on row
			if($row_id && that.config.link_pattern != '')
			{
				document.location = that.config.link_pattern.replace('__data-id__', $row_id);
			}
		}
	});

	if(this.config.ajax_url != '')
	{
		if(this.config.row_start_offset == null) this.config.row_start_offset = 0;
		this.first_request = true;
		this.preload();
	}

}

/**
 * Toggle a row
 */
myTable.fn.toggle_row = function($checkbox, $tr, $set_state)
{
	var that = this;

	var $new_state; // define the new state, that's how javascript likes it
	// to define variables first before doing something
	if($set_state === 'auto_toggle') {
		$new_state = ! $checkbox.prop('checked');
	}
	else {
		$new_state = $set_state;
	}

	// console.log($new_state);

	// var $checked = $checkbox.attr('checked', $new_state);
	$checkbox.prop("checked", $new_state);
	$tr.toggleClass('row-selected', $new_state);

	return $new_state;
}

/**
 * Toggle all rows to the state defined
 * @param  {bool} $state 	checked or unchecked
 * @return {void}
 */
myTable.fn.toggle_all_rows = function($state)
{
	var that = this;

	$("#" + this.table_id + " table tr").each(function(index)
	{
		var $checkbox;

		// search for a checkbox in the row
		$checkbox = $(this).find(':checkbox');
		that.toggle_row($checkbox, $(this).closest('tr.table-row'), $state);
	});
}

/**
 * Get selected rows
 *
 * Returns collection of jQuery objects
 */
 myTable.fn.get_selected_rows = function()
 {
 	var that = this;

 	return $("#" + this.table_id + " table tr.table-row.row-selected");
 }

/**
 * Get id's of the selected rows (comma separated)
 */
 myTable.fn.selected_ids = function()
 {
 	var that = this;

 	var $count = this.get_selected_rows().length;
 	$count--;
 	var $ids = '';

 	that.get_selected_rows().each(function(index) {
 		$ids = $ids + $(this).data('id') + ',';
 	});

    $ids = $ids.substring(0, $ids.length - 1); // rtrim last comma

    return $ids;
}

/**
 * Perform action on the selected rows
 */
 myTable.fn.selected_rows_action = function($function, $action)
 {
 	var that = this;

 	var $count = this.get_selected_rows().length;
 	$count--;
 	var $ids = '';

 	that.get_selected_rows().each(function(index) {
 		$ids = $ids + $(this).data('id') + ',';
 	});

	$ids = $ids.substring(0, $ids.length - 1); // chop off last comma

	var postData = {};
	postData['action'] = $action;
	postData['ids'] = $ids;
	postData['data'] = that.data;

	this.spinner.show();

	var $ajax = $.ajax({
		type: "POST",
		url: this.config.section_url + '/' + $function,
		data: postData,
		dataType: "json",
		cache: false,
	});

	$ajax.done(function($data)
	{
		if(that.config.post_callback)
		{
			that.config.post_callback(that, $data);
			// console.log('Excecuting post callback of table: ' + that.table_id);
		}

		that.refresh();
		that.spinner.hide();
	});

	$ajax.fail(function($response) {
		if(that.config.error_callback)
		{
			// console.log('Excecuting error callback of table: ' + that.table_id);
			that.config.error_callback(that, $response);
		}
		that.spinner.hide();
	});
}

/**
 * Throw error
 */
 myTable.fn.ajax_error = function()
 {
 	var that = this;

	// execute error callback
	if(that.config.error_callback)
	{
		// console.log('Excecuting error callback of table: ' + that.table_id);
		that.config.error_callback(that);
	}

}

/**
 * Enable/disable controls above table
 */
 myTable.fn.toggle_table_controls = function(disable)
 {
 	var that = this;

 	// only enable buttons when there are rows selected
 	// this could give some errors when more than one table is on a page
 	// there fore a fix should be applied in the form of a select_callback/refresh_callback
 	// in this callback the buttons can be disabled manually
 	if(this.get_selected_rows().length > 0) {
 		$("div.controls .onRowSelectEnable").removeClass('disabled');
 	}
 	else {
 		$("div.controls .onRowSelectEnable").addClass('disabled');
 	}

 	if(disable) {
 		$("div.controls .onRowSelectEnable").addClass('disabled');
 	}
 }

 myTable.fn.init_table_controls = function()
 {
 	var that = this;

 	this.toggle_table_controls();
 }

 myTable.fn.init_table_header = function()
 {
 	var that = this;
 	var $th_sorting = $("#" + this.table_id + ' table thead th.sorting');

 	// loop through all columns that can be sorted
 	$($th_sorting).each(function(index)
 	{
 		$(this).find('i').remove(); // remove the icon
 		var $html = $(this).html();
 		$(this).empty();

 		// add sort icon
 		$(this).append('<span class="float-start">' + $html + '</span><i class="fa fa-sort ms-auto"></i>');
 		// add an id to the column
 		$(this).attr('id', 'column_' + $(this).data('column'));
 	});

 	$($th_sorting).mousedown(function(event)
 	{
		if(event.which === 1) // left mouse button only
		{
			var $column = $(this).data('column');
			that.config.sort_column = $column;

			if($(this).data('order') == 'asc') {
				that.config.sort_order = 'desc';
			}
			else {
				that.config.sort_order = 'asc';
			}

			// if another time is clicked, the sorting could be disabled in the future

			that.refresh();
		}
	});
 }

/**
 * Reset the sorting of the tables to the default one
 * @param  {str} 	$clicked_column_id 	column_id
 * @return {void}
 */
myTable.fn.reset_table_sorting = function($clicked_column_id)
{
 	var that = this;

 	var $th_sorting = $("#" + this.table_id + ' table thead th.sorting');

 	// loop through all sortable columns and reset the order and icons
 	$($th_sorting).each(function(index)
 	{
 		if($(this).attr('id') != $clicked_column_id) {
 			$(this).data('order', '');
 		}

 		$(this).find('i')
	 		.removeClass('fa-sort-up')
	 		.removeClass('fa-sort-down');
 	});
}

/**
 * Refresh the table, the same as preload
 * Nicer to call it refresh
 *
 * @return {void}
 */
myTable.fn.refresh = function()
{
	this.preload();
}

/**
 * The actual refresh
 * @return {void}
 */
myTable.fn.preload = function()
{
	var that = this;

	// only go further when there is no ajax request yet
	// in other words when not in progress
    if(this.inProgress == true) return false;

    var postData = {};

    if( ! that.force_reset_table)
    {
    	postData["row_start_offset"] = that.config.row_start_offset;
    	postData["first_request"] = that.first_request;
    	postData["sort_column"]	= that.config.sort_column;
    	postData["sort_order"] = that.config.sort_order;
    }

    postData["row_start_offset"] = that.config.row_start_offset;
    postData['filters'] = that.config.filters;

    // show the spinner and we are in progress from this point
    // right before the ajax request
    this.spinner.show();
    this.inProgress = true;

    var $ajax = $.ajax({
    	type: "POST",
		url: this.config.ajax_url,
		data: postData,
		dataType: "json",
		cache: false,
    });

    $ajax.done(function($data) {

	    // depending on the config
	    // replace table_id table tbody
	    // replace table_id
	    $(that.config.selector).html($data.view);

		if(that.config.row_start_offset != $data.row_start_offset) {
			that.config.row_start_offset = $data.row_start_offset;
			that.refresh();
		}

		if(that.config.use_pagination == 1)
		{
			that.show_bottom();
			that.init_pagination($data);
		}

		that.config.row_start_offset = $data.row_start_offset;

		if($data.sort_column != '' && $data.sort_order != '')
		{
			var $th = $("#" + that.table_id + ' table thead #column_' + $data.sort_column);
			that.reset_table_sorting('column_' + $data.sort_column);
			var $icon = $th.find('i');

			that.config.sort_column = $data.sort_column;

			if($data.sort_order == 'asc') {
				that.config.sort_order = 'asc';
				$th.data('order', 'asc');
				$icon.addClass('fa-sort-up');
			}
			else {
				that.config.sort_order = 'desc';
				$th.data('order', 'desc');
				$icon.addClass('fa-sort-down');
			}
		}

		// we are not in progress anymore, so hide the spinner
		that.inProgress = false;
		that.spinner.hide();

		// reset "select all" checkbox
		that.toggle_all_rows(false);
		that.toggle_table_controls(true);
		$("#" + that.table_id + ' table .toggle-all-rows').removeAttr("checked");

		if(that.config.refresh_callback)
		{
			that.config.refresh_callback(that, $data);
			console.log('Excecuting refresh callback of table: ' + that.table_id);
		}
	});

	$ajax.fail(function($response)
	{
		that.force_reset_table = true;
		// notify("We're sorry: the server encountered an error.", 'error');
		that.spinner.hide();
	});

this.first_request = false;
}

/**
 * Initialize the pagination
 * @param  {data} $data data from the ajax request
 * @return {void}
 */
myTable.fn.init_pagination = function($data)
{
    var that = this;

    var $first_disabled = '';
    var $last_disabled = '';
    var $next_disabled = '';
    var $prev_disabled = '';

    var $pages = Math.ceil($data.found_rows / $data.rows_per_page);
    var $active_page = Math.floor($data.row_start_offset / $data.rows_per_page) + 1;

    if($pages <= 1) {
        $('#' + this.table_id + ' .pagination-wrap').hide();
    }
    else {
        $('#' + this.table_id + ' .pagination-wrap').show();
    }

    var $ul_object = '#' + this.table_id + ' .pagination-wrap ul';
    var $ul = $($ul_object);
    $ul.empty();

    // first
    var $offset_first = 0;
    if($active_page == 1) $first_disabled = ' disabled';
    if(this.config.label_first == undefined) this.config.label_first = '&laquo;';
    $ul.append('<li class="page-item first ' + $first_disabled + '" data-offset="' + $offset_first + '"><a class="page-link">' + this.config.label_first + '</a></li>');

    // previous
    var $offset_prev = ($active_page - 2) * $data.rows_per_page;
    if($active_page == 1) $prev_disabled = ' disabled';
    $ul.append('<li class="page-item prev ' + $prev_disabled + '" data-offset="' + $offset_prev + '"><a class="page-link">' + this.config.label_prev + '</a></li>');

    var $for_start = $active_page - 3;
    var $for_until = $active_page + 2;

    if($for_until >= $pages) {
        $for_until = $pages;
    }

    if($for_start < 0) {
        $for_start = 0;
    }

    for(var $i = $for_start; $i < $for_until; $i++)
    {
        var $page_num = $i + 1;
        var $offset = $i * $data.rows_per_page;

        if($page_num == $active_page) {
            $ul.append('<li class="page-item active"><a class="page-link">' + $page_num + '</a></li>');
        }
        else {
            $ul.append('<li class="page-item" data-offset="' + $offset + '"><a class="page-link">' + $page_num + '</a></li>');
        }
    }

    // next
    var $offset_next = null;
    if($active_page == $pages) {
        $next_disabled = ' disabled';
    }
    else {
        $offset_next = ($active_page) * $data.rows_per_page;
    }
    $ul.append('<li class="page-item next ' + $next_disabled + '" data-offset="' + $offset_next + '"><a class="page-link">' + this.config.label_next + '</a></li>');

    // last
    var $offset_last = ($pages - 1) * $data.rows_per_page;
    if($active_page == $pages) $last_disabled = ' disabled';
    if(this.config.label_last == undefined) this.config.label_last = '&raquo;';
    $ul.append('<li class="page-item last ' + $last_disabled + '" data-offset="' + $offset_last + '"><a class="page-link">' + this.config.label_last + '</a></li>');

    // click event
    $($ul_object + ' li').mousedown(function(event)
    {
        if(!$(this).hasClass('disabled') && !$(this).hasClass('active'))
        {
            if(event.which === 1)
            {
                var offset = $(this).data('offset');
                if(offset !== null && offset !== undefined)
                {
                    that.config.row_start_offset = offset;
                    that.refresh();
                }
            }
        }
    });

    // stats
    if($data.found_rows > 0) {
        var $label = this.config.label_found_rows.replace('%FOUND_ROWS%', $data.found_rows);
        $('#' + this.table_id + ' .table-stats').html('<strong>' + $label + '</strong>');
    }
}

/**
 * Show the bottom of the table
 * e.g. table stats and pagination
 *
 * @return {void}
 */
myTable.fn.show_bottom = function()
{
	var that = this;

    var $element = $('#' + this.table_id + ' .bottom-row');

	// bootstrap 2 based
	if(this.config.bootstrap == 2) {
        var $template_bottom = '<div class="row bottom-row">' +
		'<div class="span3 hide-979 float-start table-stats">&nbsp;</div>' +
		'<div class="span6 float-end pagination-wrap">' +
			'<div class="pagination pagination-medium pagination-right" style="margin:0"><ul></ul></div>' +
		'</div>' +
		'</div>';
	}

	// bootstrap 3 based
	if(this.config.bootstrap == 3) {
		$template_bottom = '<div class="row bottom-row">' +
		'<div class="col-lg-4 float-start table-stats">&nbsp;</div>' +
		'<div class="col-lg-8 float-end pagination-wrap">' +
			'<div class="navigation"><ul class="pagination float-end"></ul></div>' +
		'</div>' +
		'</div>';
	}
    // bootstrap 5 based
    if(this.config.bootstrap == 5) {
        $template_bottom = '<div class="row bottom-row mt-3">' +
            '<div class="col-md-4 float-start table-stats"></div>' +
            '<div class="col-md-8 pagination-wrap">' +
            '<nav class="float-end"><ul class="pagination"></ul></nav>' +
            '</div>' +
            '</div>';
    }

	if($element.length == 0) // check if already exists
	{
		$('#' + this.table_id).append($template_bottom);
	}
}

// --------------------
// End of prototype table

/**
 * Delaykeyup function
 * @param  {Function} 	callback 	callback function
 * @param  {int}		ms       	delay after callback will be executed
 * @return {void}
 */
 $.fn.delayKeyup = function(callback, ms){
 	var timer = 0;
 	$(this).keyup(function(){
 		clearTimeout (timer);
 		timer = setTimeout(callback, ms);
 	});
 	return $(this);
 }

/**
 * Convert form data to JSON
 * @param  {array} options
 * @return {json}
 */
 $.fn.toJSON = function(options){

 	options = $.extend({}, options);

 	var self = this,
 	json = {},
 	push_counters = {},
 	patterns = {
 		"validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
 		"key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
 		"push":     /^$/,
 		"fixed":    /^\d+$/,
 		"named":    /^[a-zA-Z0-9_]+$/
 	};


 	this.build = function(base, key, value){
 		base[key] = value;
 		return base;
 	};

 	this.push_counter = function(key){
 		if(push_counters[key] === undefined){
 			push_counters[key] = 0;
 		}
 		return push_counters[key]++;
 	};

 	$.each($(this).serializeArray(), function(){

        // skip invalid keys
        if(!patterns.validate.test(this.name)){
        	return;
        }

        var k,
        keys = this.name.match(patterns.key),
        merge = this.value,
        reverse_key = this.name;

        while((k = keys.pop()) !== undefined){

            // adjust reverse_key
            reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

            // push
            if(k.match(patterns.push)){
            	merge = self.build([], self.push_counter(reverse_key), merge);
            }

            // fixed
            else if(k.match(patterns.fixed)){
            	merge = self.build([], k, merge);
            }

            // named
            else if(k.match(patterns.named)){
            	merge = self.build({}, k, merge);
            }
        }

        json = $.extend(true, json, merge);
    });

 	return json;
 }
